import { throttle } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { SvgIconHandler } from "../svg-icon-hadler";

import "./search-box.m.css";

const SearchBox = ({ height = "16px", width = "16px" }) => {
  const [searchBox, showSearchBox] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    window.location.href = `/search?q=${inputValue}`;
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        showSearchBox(false);
      }
    };

    document.addEventListener("mousedown", throttle(handleClickOutside, 250));

    return () => {
      document.removeEventListener("mousedown", throttle(handleClickOutside, 250));
    };
  }, []);

  return (
    <>
      <div styleName="search-wrapper" ref={dropdownRef}>
        <button onClick={() => showSearchBox(!searchBox)} styleName="search-box">
          <SvgIconHandler type="search" height={height} width={width} />
        </button>
        {searchBox && (
          <form onSubmit={handleSubmit}>
            <div styleName="search-container">
              <div styleName="triangle"></div>
              <input
                placeholder="Search here..."
                type="text"
                styleName="search-input-box"
                value={inputValue}
                onChange={handleChange}
                autoFocus
              />
              <button styleName="search-btn" type="submit">
                <SvgIconHandler type="search" height="18px" width="18px" />
              </button>
            </div>
          </form>
        )}
      </div>
    </>
  );
};

export default SearchBox;
